import { Pipe, PipeTransform } from '@angular/core';
import { IAttachmentDto, ISpeaker } from '@common/types';

@Pipe({ name: 'getSpeakerMaterials' })
export class GetSpeakerMaterialPipe implements PipeTransform {
  transform(speaker: ISpeaker, materials: IAttachmentDto[]): IAttachmentDto[] {
    return materials.filter((m) => m.createdBy.id === speaker.employee.id);
  }
}
